module.exports = __webpack_public_path__ + "static/media/honda_servicio_icon.7ed2bb65.svg";